// extracted by mini-css-extract-plugin
module.exports = {"full-spinner":"spinner_component_full-spinner__TjhS2","tiny-spinner":"spinner_component_tiny-spinner__nq96r","big-spinner":"spinner_component_big-spinner__F84F7"};